// Centralised date/time formatting for the app.
// All timestamps are stored in UTC and DISPLAYED in America/Edmonton (Mountain Time).

export const SCHOOL_TZ = "America/Edmonton";

// Full date + time, e.g. "Jun 9, 2026, 9:03 PM"
export function fmtDateTime(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleString("en-US", {
    timeZone: SCHOOL_TZ,
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

// Weekday + time, e.g. "Mon, 9:03 PM" (used for clock-in "since")
export function fmtWeekdayTime(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleString("en-US", {
    timeZone: SCHOOL_TZ,
    weekday: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
}

// Date-only string "YYYY-MM-DD" -> "Mon, Jun 9, 2026" (no timezone shift)
export function fmtDateOnly(dateStr) {
  if (!dateStr) return "—";
  const [y, m, d] = dateStr.split("-").map(Number);
  return new Date(y, m - 1, d).toLocaleDateString("en-US", {
    weekday: "short",
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}

// Compact class-day label "YYYY-MM-DD" -> "Thu Jun 8" (no year, no tz shift)
export function fmtClassDay(dateStr) {
  if (!dateStr) return "—";
  const [y, m, d] = dateStr.split("-").map(Number);
  return new Date(y, m - 1, d).toLocaleDateString("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
  });
}

// UTC ISO -> value for <input type="datetime-local"> shown in Mountain Time
export function isoToMTInput(iso) {
  if (!iso) return "";
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: SCHOOL_TZ,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  }).formatToParts(new Date(iso));
  const g = (t) => parts.find((p) => p.type === t).value;
  return `${g("year")}-${g("month")}-${g("day")}T${g("hour")}:${g("minute")}`;
}

// "YYYY-MM-DDTHH:mm" (interpreted as Mountain Time) -> UTC ISO string
export function mtInputToISO(local) {
  if (!local) return null;
  const [datePart, timePart] = local.split("T");
  const [y, mo, da] = datePart.split("-").map(Number);
  const [h, mi] = timePart.split(":").map(Number);
  const utcGuess = Date.UTC(y, mo - 1, da, h, mi);
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: SCHOOL_TZ,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  }).formatToParts(new Date(utcGuess));
  const g = (t) => Number(parts.find((p) => p.type === t).value);
  const mtMillis = Date.UTC(g("year"), g("month") - 1, g("day"), g("hour"), g("minute"));
  const offset = mtMillis - utcGuess; // how far MT wall-clock leads UTC at this instant
  return new Date(utcGuess - offset).toISOString().replace("Z", "+00:00");
}
